<template>
  <v-app style="background-color: #e9e9e9">
    <v-img
      src="../../assets/background.svg"
      alt="Hive background"
      style="position: fixed"
      height="100%"
    />

    <v-dialog v-model="patchDialog" width="700" class="font">
      <PatchNotes :registerNote="registerNote" />
    </v-dialog>

    <Navigation
      :chatIsOpen="chat"
      :key="update"
      @openNotes="patchDialog = true"
    />

    <v-main class="font" style="z-index: 1">
      <v-scroll-x-transition>
        <Chat v-if="chat" @close="chat = false" />
      </v-scroll-x-transition>

      <v-container class="fill-height">
        <router-view @updateProfileImage="updateProfile" />
      </v-container>
    </v-main>

    <v-dialog v-model="alertDialog" persistent max-width="360" class="font">
      <v-card rounded elevation="3" style="background-color: #f9f9f9">
        <div
          class="d-flex align-center"
          style="
            background-color: #426483;
            color: white;
            padding: 10px;
            border-radius: 4px 4px 0 0;
          "
        >
          <strong class="ml-2" style="font-size: 18px">{{
            $t('Alertas pendentes')
          }}</strong>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeAlertDialog" dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="text-center" style="font-size: 16px; color: #333">
          <p class="ma-0">
            {{ $t('Você possui ') }}
            <b style="color: #b14949">{{ alertQuantity }}</b>
            {{ $t(' alerta(s) sem visualização.') }}
          </p>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn
            class="ma-1"
            color="grey lighten-1"
            outlined
            @click="closeAlertDialog"
          >
            {{ $t('Fechar') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="ma-1"
            color="#B14949"
            dark
            @click="callAlertList"
          >
            {{ $t('Visualizar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<style lang="scss" scoped>
@import '@/sass/variables.scss';
.font {
  font-family: 'Poppins', sans-serif;
}

.successAlert {
  z-index: 100;
  position: absolute;
  right: 2%;
  top: 10%;
  white-space: nowrap;
}

.backAlertTitle {
  background-color: #426483;
  color: #fff;
}

@media (max-width: 400px) {
  .successAlert {
    position: absolute;
    right: 7%;
    left: 7%;
  }
}
</style>

<script>
import PatchNotes from './PatchNotes'
import Navigation from './Navigation'
import ApiService from '../../services/ApiService'
import Component from '../../components/toast.vue'
import Utils from '../../Utils/FormatDate'
import Chat from '../../components/chat/chat.vue'

export default {
  name: 'Authenticated',

  async created() {
    this.interval = setInterval(() => {
      this.checkSessionId()
    }, 300000)

    this.getAlertsPending()

    this.$root.$on('OpenNotes', this.openNotes)
    this.$root.$on('chat', this.openChat)

    const user = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))
    if (
      institution.id == user.institutionId &&
      user.pendingCalleds &&
      user.pendingCalleds.length > 0
    ) {
      this.$toast(Component, {
        position: 'top-right',
        timeout: 10000,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: false,
        draggablePercent: 0.6,
        showCloseButtonOnHover: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      })
    }
  },

  destroyed() {
    clearInterval(this.interval)
    if (this.interval) {
      this.interval = null
    }
  },

  beforeDestroy() {
    clearInterval(this.interval)
    if (this.interval) {
      this.interval = null
    }
  },

  data: () => ({
    patchDialog: false,
    interval: null,
    update: false,
    message: '',
    alertDialog: false,
    alertQuantity: 0,
    apiService: new ApiService(),
    registerNote: false,
    chat: false,
  }),

  components: {
    Navigation,
    PatchNotes,
    Chat,
  },

  methods: {
    checkSessionId() {
      const user = localStorage.getItem('user')

      if (user) {
        const jsonUser = JSON.parse(user)

        this.apiService
          .get(`user/check-session/${jsonUser.sessionId}`, null, false, false)
          .then((resp) => {
            if (resp.content.requireAuthenticate) {
              localStorage.removeItem('institution')
              localStorage.removeItem('token')
              localStorage.removeItem('expires')
              localStorage.removeItem('user')
              this.$router.push('/auth')
            }
          })
      }
    },

    openNotes(toOpen) {
      this.registerNote = true
      this.patchDialog = toOpen
      setTimeout(() => {
        this.registerNote = false
      }, 500)
    },

    openChat() {
      this.chat = true
    },

    updateProfile() {
      this.update = !this.update
    },

    async getAlertsPending() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      const alerts = []

      await this.apiService
        .get(`alert/getPending/${institutionId}`, null, true, false)
        .then((response) => {
          response.content.map((alert) => {
            if (!this.compareDatetime(alert.alertDateTime)) {
              alerts.push(alert)
            }
            if (alerts.length) {
              if (this.$router.history.current.name != 'alert') {
                this.alertDialog = true
                this.alertQuantity = alerts.length
              }
            }
          })
        })
    },

    compareDatetime(datetime) {
      return Utils.compareDateTime(datetime)
    },

    callAlertList() {
      this.$router.push('/alert')
      this.closeAlertDialog()
    },

    closeAlertDialog() {
      this.alertDialog = false
    },
  },
}
</script>
